import React from "react";
import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import {
  collection,
  getDocs,
  doc,
  updateDoc,
  query,
  where,
} from "firebase/firestore";
import { auth, db } from "../../../../firebase";
import { toast } from "react-hot-toast";
import { BsInfoCircleFill } from "react-icons/bs";

import { Col, Row, Radio, Table, Form, Input, Select, Space } from "antd";

import ConfirmationBox from "../../../../components/common/ConfirmationBox";
import TextArea from "antd/es/input/TextArea";

import "./AllGuestCards.css";
import { useAuthState } from "react-firebase-hooks/auth";

function AllGuestCards({ data }) {
  const navigate = useNavigate();
  const [user, loading] = useAuthState(auth);
  const [companyName, setCompanyName] = useState("");
  const [isCompanyNameFetched, setIsCompanyNameFetched] = useState(false);
  const [radioValue, setRadioValue] = useState("");
  const [sortedInfo, setSortedInfo] = useState({});
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [emailSendBoxOpen, setEmailSendBoxOpen] = useState(false);
  const [assignUserBoxOpen, setAssignUserBoxOpen] = useState(false);
  const [selecttedUser, setSelectedUser] = useState("");
  const [assignedUser, setAssignedUser] = useState("");
  const [users, setUsers] = useState([]);

  const radioGroupRef = useRef(null);
  const handleBlur = () => {
    if (radioGroupRef.current) {
      radioGroupRef.current.blur();
    }
  };

  const fetchCompanyName = async () => {
    try {
      const usersRef = collection(db, "allUsers");
      const userData = query(usersRef, where("uid", "==", user?.uid));
      const querySnapshot = await getDocs(userData);
      querySnapshot.forEach((doc) => {
        const res = doc.data();
        setCompanyName(res.companyName);
      });
      setIsCompanyNameFetched(true);
    } catch (error) {
      console.log("Error getting company name: ", error);
    }
  };
  useEffect(() => {
    fetchCompanyName();
  }, [user, loading]);

  useEffect(() => {
    if (!isCompanyNameFetched) return;
    const fetchUsers = async () => {
      try {
        const usersRef = collection(db, "companies", companyName, "users");
        const snapshot = await getDocs(usersRef); // Use getDocs to fetch the collection

        const fetchedData = snapshot.docs.map((doc) => ({
          id: doc.id,
          value:
            doc.data().profile.firstName + " " + doc.data().profile.lastName,
          ...doc.data(),
        }));

        setUsers(fetchedData);
      } catch (err) {
        console.error(err);
        alert(err.message);
      }
    };
    fetchUsers();
  }, [companyName, isCompanyNameFetched]);

  useEffect(() => {
    if (!isCompanyNameFetched) return;

    if (radioValue === "sendemail") {
      setEmailSendBoxOpen(true);
    } else if (radioValue === "assignuser") {
      setAssignUserBoxOpen(true);
    } else {
      const selectedData = data.filter((item) =>
        selectedRowKeys.includes(item.id)
      );
      const status = {
        status: "",
      };
      try {
        selectedData.forEach((document) => {
          if (document) {
            // Modify the necessary fields or values in the document object
            switch (radioValue) {
              case "inactive": {
                status.status = "inactive";
                break;
              }
              case "active": {
                status.status = "active";
                break;
              }
              case "waitlisted": {
                status.status = "waitlisted";
                break;
              }
              default: {
                console.log("Inavalid input");
                break;
              }
            }
            try {
              // Update the document in Firestore
              const guestCardRef = doc(
                db,
                "companies",
                companyName,
                "guestCards",
                document.id
              );
              updateDoc(guestCardRef, status);

              toast.success("Status updated successfully");
            } catch (error) {
              console.error("Error updating document:", error);
            }
          }
        });
      } catch (err) {
        toast.error("Something wrong with document");
      }
    }
  }, [companyName, isCompanyNameFetched, radioValue]);

  const onSelectChange = (newSelectedRowKeys) => {
    console.log("selectedRowKeys changed: ", newSelectedRowKeys);
    setSelectedRowKeys(newSelectedRowKeys);
  };
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const handleChange = (sorter) => {
    setSortedInfo(sorter);
  };

  const onChange = (e) => {
    setRadioValue(e.target.value);
  };

  const assignUser = () => {
    const selectedData = data.filter((item) =>
      selectedRowKeys.includes(item.id)
    );
    try {
      selectedData.forEach((document) => {
        if (document) {
          // Modify the necessary fields or values in the document object
          const assignTo = {
            "guestContact.assignTo": selecttedUser,
          };
          try {
            // Update the document in Firestore
            const guestCardRef = doc(
              db,
              "companies",
              companyName,
              "guestCards",
              document.id
            );
            switch (assignedUser) {
              case 1: {
                if (
                  document.guestContact.assignTo === "" ||
                  document.guestContact.assignTo === "unassigned"
                ) {
                  updateDoc(guestCardRef, assignTo);
                }
                break;
              }
              case 2: {
                updateDoc(guestCardRef, assignTo);
                break;
              }
            }
            setAssignUserBoxOpen(false);
          } catch (error) {
            console.error("Error updating document:", error);
          }
        }
      });
      toast.success("Assigned user successfully");
    } catch (err) {
      toast.success("Error with document: ", err);
    }
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (_, record) => (
        <span className="onclick-text">
          {record.guestContact?.firstName} {record.guestContact?.lastName}
        </span>
      ),
      sorter: (a, b) => a.name.length - b.name.length,
      sortOrder: sortedInfo.columnKey === "name" ? sortedInfo.order : null,
      ellipsis: true,
    },
    {
      title: "Interested In",
      dataIndex: "interestedIn",
      key: "interestedIn",
      render: (_, record) =>
        record?.guestInterests
          ? Object.keys(record?.guestInterests).map((key) => {
              return <span key={key}>{record?.guestInterests[key]}, </span>;
            })
          : null,
      sorter: (a, b) => a.interestedIn.length - b.interestedIn.length,
      sortOrder:
        sortedInfo.columnKey === "interestedIn" ? sortedInfo.order : null,
      ellipsis: true,
    },
    {
      title: "Last Inquiry",
      dataIndex: "lastInquiry",
      key: "lastInquiry",
      render: (_, record) => <span>text sent</span>,
      sorter: (a, b) => a.lastInquiry.length - b.lastInquiry.length,
      sortOrder:
        sortedInfo.columnKey === "lastInquiry" ? sortedInfo.order : null,
      ellipsis: true,
    },
    {
      title: "Most Recent Activity",
      dataIndex: "activity",
      key: "activity",
      render: (_, { activity }) => <span>01/03/2023</span>,
      sorter: (a, b) => a.activity.length - b.activity.length,
      sortOrder: sortedInfo.columnKey === "activity" ? sortedInfo.order : null,
      ellipsis: true,
    },
    {
      title: "Source",
      dataIndex: "Source",
      key: "Source",
      render: (_, record) => <span>{record.guestContact?.source}</span>,
      sorter: (a, b) => a.Source.length - b.Source.length,
      sortOrder: sortedInfo.columnKey === "Source" ? sortedInfo.order : null,
      ellipsis: true,
    },
  ];

  return (
    <>
      <Col span={24}>
        <Row justify="start" gutter={[0, 16]}>
          <Col span={24}>
            <Radio.Group onChange={onChange} ref={radioGroupRef}>
              <Radio.Button
                value="bulk"
                className="bulk-actions"
                disabled={true}
                onClick={handleBlur}
              >
                Bulk Actions
              </Radio.Button>
              <Radio.Button
                value="active"
                disabled={selectedRowKeys.length < 1 ? true : false}
                onClick={handleBlur}
              >
                Mark Active
              </Radio.Button>
              <Radio.Button
                value="inactive"
                disabled={selectedRowKeys.length < 1 ? true : false}
                onClick={handleBlur}
              >
                Mark Inactive
              </Radio.Button>
              <Radio.Button
                value="waitlisted"
                disabled={selectedRowKeys.length < 1 ? true : false}
                onClick={handleBlur}
              >
                Mark Waitlisted
              </Radio.Button>
              <Radio.Button
                value="sendemail"
                disabled={selectedRowKeys.length < 1 ? true : false}
              >
                Send Email
              </Radio.Button>
              <Radio.Button
                value="assignuser"
                disabled={selectedRowKeys.length < 1 ? true : false}
                onClick={handleBlur}
              >
                Assign User
              </Radio.Button>
            </Radio.Group>
          </Col>
          <Col span={24}>
            <Table
              className="card-container"
              columns={columns}
              dataSource={data}
              onChange={handleChange}
              rowKey={(record) => record.id}
              rowSelection={rowSelection}
              onRow={(record) => {
                return {
                  onClick: () => {
                    navigate(`/leasing/guest-cards/${record.id}`);
                  },
                };
              }}
            />
          </Col>
        </Row>
      </Col>
      {emailSendBoxOpen ? (
        <ConfirmationBox setIsConfirmationBoxOpen={setEmailSendBoxOpen}>
          <h2>Send Email</h2>
          <Form layout="vertical">
            <Form.Item label="Recipients" required>
              <Input placeholder="Jessica William" />
              <p className="silver-text">
                A separate email will be sent to each recipient for privacy
              </p>
            </Form.Item>
            <Form.Item label="Additional Recipients">
              <Input placeholder="Type to search" />
            </Form.Item>
            <Form.Item label="Subject" required>
              <Input placeholder="Enter subject" />
            </Form.Item>
            <Form.Item label="Message" required>
              <TextArea placeholder="Enter message" rows={8} />
            </Form.Item>
          </Form>
          <div className="action-buttons">
            <button className="blue" onClick={() => setEmailSendBoxOpen(false)}>
              Save
            </button>
            <button
              className="cancel-btn"
              onClick={() => setEmailSendBoxOpen(false)}
            >
              cancel
            </button>
            <span className="onclick-text">Customize My Signature</span>
          </div>
        </ConfirmationBox>
      ) : null}
      {assignUserBoxOpen ? (
        <ConfirmationBox setIsConfirmationBoxOpen={setAssignUserBoxOpen}>
          <h2>Assign User to Guest Cards</h2>
          <div className="message-container">
            <BsInfoCircleFill size={18} />
            <span>This will override any previously assigned user.</span>
          </div>
          <Form layout="vertical">
            <Form.Item label="Assign User">
              <Select
                options={users}
                placeholder="Select"
                showSearch
                allowClear
                value={selecttedUser}
                onChange={(value) => setSelectedUser(value)}
              />
            </Form.Item>
            <Form.Item>
              <Radio.Group
                className="radio-margin"
                value={assignedUser}
                onChange={(e) => setAssignedUser(e.target.value)}
              >
                <Space direction="vertical">
                  <Radio value={1}>
                    Assign user only to unassigned inquiries
                  </Radio>
                  <Radio value={2}>Assign user to all inquiries</Radio>
                </Space>
              </Radio.Group>
            </Form.Item>
          </Form>
          <div className="action-buttons">
            <button className="blue" onClick={() => assignUser()}>
              Assign
            </button>
            <button
              className="cancel-btn"
              onClick={() => setAssignUserBoxOpen(false)}
            >
              cancel
            </button>
          </div>
        </ConfirmationBox>
      ) : null}
    </>
  );
}

export default AllGuestCards;
